
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSubmarineCables as ObiChartSubmarineCablesElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-submarine-cables.js';
 
 
 

 
 export const ObiChartSubmarineCables = createComponent({
   react: React,
   tagName: 'obi-chart-submarine-cables',
   elementClass: ObiChartSubmarineCablesElement,
   events: {
     
   }
  });
 
 